import { render } from "./clinic-show.vue?vue&type=template&id=2176587d&scoped=true"
import script from "./clinic-show.vue?vue&type=script&lang=js"
export * from "./clinic-show.vue?vue&type=script&lang=js"

import "./clinic-show.vue?vue&type=style&index=0&id=2176587d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2176587d"]])

export default __exports__